import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/energy-usage/EnergyUsageDaily/.eu';
import Kr from '@di-shared/features/history/energy-usage/EnergyUsageDaily/.kr';
import Na from '@di-shared/features/history/energy-usage/EnergyUsageDaily/.na';

export interface EnergyUsageDailyProps {
  vin: string;
}

export default function EnergyUsageDaily({vin}: EnergyUsageDailyProps) {
  return (
    <>
      <Environment.Eu>
        <Eu vin={vin} />
      </Environment.Eu>
      <Environment.Kr>
        <Kr vin={vin} />
      </Environment.Kr>
      <Environment.Na>
        <Na vin={vin} />
      </Environment.Na>
    </>
  );
}
